export default "__VITE_ASSET__CxWVkmZ4__"